module.exports = __webpack_public_path__ + "img/1528356252.ea1f4446.jpg";